import {
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    OnInit,
    inject,
    viewChild,
    input,
    output,
} from '@angular/core'
import { ColorPickerService } from '@app/shared/color-picker/color-picker.service'
import { SetType } from '@app/shared/models/picker'
import { TbPickerComponent } from '@components-library/tb-picker/tb-picker.component'

export type PickerColor = {
    color: string
    isDefault?: boolean
}

@Component({
    selector: 'app-color-picker',
    templateUrl: './color-picker.component.html',
    styleUrl: './color-picker.component.sass',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TbPickerComponent],
})
export class ColorPickerComponent implements OnInit {
    private readonly colorPickerService = inject(ColorPickerService)

    private triggerItem = viewChild.required<ElementRef>('triggerItem')

    set = input.required<SetType>()
    subtitle = input.required<string>()
    name = input<string>()
    color = input<string>()

    colorChange = output<PickerColor>()

    pickerItems!: string[]

    selectedColor!: string

    ngOnInit() {
        this.pickerItems = this.colorPickerService.getColorSet(this.set())

        this.selectedColor = this.getColor()

        if (!this.color()) {
            this.colorChange.emit({ color: this.selectedColor, isDefault: true })
        }
    }

    selectColor(color: string | null) {
        this.selectedColor = color ?? this.colorPickerService.getDefaultColor(this.set())
        this.colorChange.emit({ color: this.selectedColor })
    }

    open() {
        this.triggerItem().nativeElement.click()
    }

    private getColor() {
        const color = this.color()
        if (!color) {
            return this.colorPickerService.getDefaultColor(this.set())
        }

        return color
    }
}
